"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default() {
  return "\n<div class=\"row\">\n    <div class=\"row\">\n        <div class=\"large-5 small-8 small-centered columns\">\n            <div class=\"error-container text-center\" style=\"margin-top:70px\">\n                <div data-alert class=\"alert-box alert radius\">\n                    ".concat(window.text('error.errorContactSupport', {
    link: "<a class=\"bold\" href=\"".concat(window.url(window.routes.supportMembers), "\" tabindex=\"0\">").concat(window.html('pleaseContactSupport'), "</a>")
  }), "\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
};

exports["default"] = _default;